import { useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { hasPrivilege } from "../api/token";


export default function CHAT() {
    const navigate = useNavigate();

    useEffect(() => {
      if (!hasPrivilege('chat_view')) {
        navigate("/");
      }

      const URL_CHAT = import.meta.env.VITE_CHAT;
      window.open(URL_CHAT, "_blank");
      navigate("/");

    }, [navigate])
}
